import React from 'react';
import { cn } from '@/shared/utils/cn.ts';

type FieldsetGroupProps = {
    title?: string;
    label?: string;
    children: React.ReactNode;
};

export function FieldsetGroup({ title, label, children }: FieldsetGroupProps) {
    return (
        <div className="flex flex-col gap-4">
            {title && label ? (
                <div className="flex flex-col gap-1">
                    <h3 className="font-copy-md-strong">{title}</h3>
                    <FieldsetLabel>{label}</FieldsetLabel>
                </div>
            ) : (
                <>
                    {title && <h3 className="font-copy-md-strong">{title}</h3>}
                    {label && <FieldsetLabel>{label}</FieldsetLabel>}
                </>
            )}
            {children}
        </div>
    );
}

type FieldsetProps = {
    title?: string;
    className?: string;
    dataTest?: string;
    children: React.ReactNode;
};

export function Fieldset({ title, className, dataTest, children }: FieldsetProps) {
    return (
        <fieldset className={cn('flex flex-col gap-4', className)} data-test={dataTest}>
            {title && <legend className="font-copy-xs-strong uppercase">{title}</legend>}
            {children}
        </fieldset>
    );
}

type FieldsetBodyProps = {
    className?: string;
    children: React.ReactNode;
};

export function FieldsetBody({ className, children }: FieldsetBodyProps) {
    return <div className={cn('grid grid-cols-1 gap-2', className)}>{children}</div>;
}

type FieldsetColumnProps = {
    label?: string;
    children: React.ReactNode;
    className?: string;
};

export function FieldsetColumn({ label, children, className }: FieldsetColumnProps) {
    return (
        <div className={cn('flex flex-col gap-1', className)}>
            {label && <FieldsetLabel>{label}</FieldsetLabel>}
            {children}
        </div>
    );
}

type FieldsetLabelProps = {
    children: React.ReactNode;
    className?: string;
};

export function FieldsetLabel({ children, className }: FieldsetLabelProps) {
    return <span className={cn('font-copy-sm text-subdued truncate', className)}>{children}</span>;
}
